import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ill_spot_info_tnc.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-4ae68bc3")

_pushScopeId("data-v-4ae68bc3")
const _hoisted_1 = { class: "text-gray-lp-300 font-semibold text-xl" }
const _hoisted_2 = { class: "text-gray-lp-300" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center justify-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    width: "287.66",
    alt: "info"
  })
], -1)
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "flex flex-row items-center gap-2 py-4 border-t border-gray-lp-1600" }
const _hoisted_6 = {
  class: "text-sm",
  style: {"line-height":"17.07px"}
}
const _hoisted_7 = { class: "flex flex-row items-center gap-2 py-4 border-t border-gray-lp-1600" }
const _hoisted_8 = {
  class: "text-sm",
  style: {"line-height":"17.07px"}
}
const _hoisted_9 = { class: "flex flex-row items-center gap-2 py-4 border-t border-b border-gray-lp-1600" }
const _hoisted_10 = {
  class: "text-sm",
  style: {"line-height":"17.07px"}
}
const _hoisted_11 = {
  href: "https://bit.ly/SKCommodityLionParcel",
  target: "_blank",
  class: "text-red-lp-200 font-bold"
}
const _hoisted_12 = { class: "flex flex-col gap-6" }
const _hoisted_13 = { class: "flex flex-row items-center" }
const _hoisted_14 = {
  class: "text-xs text-gray-lp-300 font-semibold",
  style: {"margin-left":"2.5px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(_component_ModalV2, {
        key: 0,
        isCustomTitle: "",
        width: "instant-booking-popup",
        onClose: _ctx.onCloseModal
      }, {
        "custom-title": _withId(() => [
          _createVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.importantInformation")), 1)
        ]),
        content: _withId(() => [
          _createVNode("section", _hoisted_2, [
            _hoisted_3,
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.agreements[0],
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.agreements[0] = $event)),
                  binary: ""
                }, null, 8, ["modelValue"]),
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.agreementCommodityMatch")), 1)
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.agreements[1],
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.agreements[1] = $event)),
                  binary: ""
                }, null, 8, ["modelValue"]),
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.agreementCommodityDefault")), 1)
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.agreements[2],
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.agreements[2] = $event)),
                  binary: ""
                }, null, 8, ["modelValue"]),
                _createVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.agreementForbiddenCommodity")) + " ", 1),
                  _createVNode("a", _hoisted_11, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.viewDetails")), 1)
                ])
              ])
            ])
          ])
        ]),
        footer: _withId(() => [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_Checkbox, {
                binary: true,
                modelValue: _ctx.isAgree,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isAgree = $event)),
                disabled: _ctx.isNotValid
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.confirmBookingAgreement")), 1)
            ]),
            _createVNode(_component_LpButton, {
              disabled: !_ctx.isAgree,
              isWidthFull: "",
              title: _ctx.$t('bookingShipment.appsMarketplace.continueBooking'),
              textColor: "white",
              customClass: "py-3",
              onClick: _ctx.onConfirm
            }, null, 8, ["disabled", "title", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
})